import { H6, Image, P } from "../../AbstractElements";
import { MARKJENCOEMAIL, MarkJecno } from "../../Constant";
import Img from "../../assets/images/user/user.png";

const UseProfile = () => {
  return (
    <div className="d-flex">
      <div className="d-flex-size-email">
        <Image className="me-3 rounded-circle" src={Img} alt="" />
      </div>
      <div className="flex-grow-1">
        <H6 className="f-w-600 text-uppercase">{MarkJecno}</H6>
        <P>{MARKJENCOEMAIL}</P>
      </div>
    </div>
  );
};

export default UseProfile;
